/*example*/
/*splitting-framework-bindings-using-entrypoints*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "库中的框架绑定",
  "description": "了解如何在包中创建框架绑定。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "库软件包 中的框架绑定通过在库中直接利用框架的 API，将你的库代码与框架更深入地集成。"
  }, {
    "heading": "",
    "content": "¥Framework bindings in a Library Package integrate your library's code more deeply with a framework by leveraging APIs from the framework directly in the library."
  }, {
    "heading": "",
    "content": "为此，请在库的 package.json 中使用 peerDependencies 字段，这使得框架 API 在你的库中可用，而无需将其直接安装在包中。"
  }, {
    "heading": "",
    "content": "¥To do this, use the peerDependencies field in package.json of the library, which makes the framework APIs available in your library without installing it directly in the package."
  }, {
    "heading": "",
    "content": "在本页面中，我们将使用 Next.js 作为示例，但以下概念适用于任何框架或其他依赖。"
  }, {
    "heading": "",
    "content": "¥On this page, we'll be using Next.js for examples, but the concepts below\napply to any framework or other dependency."
  }, {
    "heading": "示例-example",
    "content": "¥Example"
  }, {
    "heading": "示例-example",
    "content": "将 peerDependency 添加到你要为其创建绑定的依赖的库中。"
  }, {
    "heading": "示例-example",
    "content": "¥Add a peerDependency to your library for the dependency that you intend to create bindings for."
  }, {
    "heading": "示例-example",
    "content": "在上面的示例中，next 的 peerDependency 接受任何版本。你可能需要根据需要指定一个范围（例如，\">=15\"）。此外，对于较旧的包管理器，你可能需要指示包管理器使用配置安装对等依赖，或者将依赖添加到 devDependencies 作为解决方法。"
  }, {
    "heading": "示例-example",
    "content": "¥In the example above, the peerDependency for next accepts any version. You\nmay want to specify a range (for example, \">=15\") according to your needs.\nAdditionally, for older package managers, you may need to instruct your\npackage manager to install peer dependencies with configuration, or add the\ndependency to devDependencies as a workaround."
  }, {
    "heading": "示例-example",
    "content": "这将使依赖在你的库中可用，允许你编写如下所示的代码。注意 className 属性，它为 monorepo 中的组件设置了默认样式，并且可以在 props 对象中覆盖它。"
  }, {
    "heading": "示例-example",
    "content": "¥This will make the dependency available in your library, allowing you to write code like below. Note the className prop, which sets a default styling for this component in the monorepo and can be overridden in the props object."
  }, {
    "heading": "示例-example",
    "content": "将为包解析的 next 版本将来自库的使用者。例如，如果你的应用中安装了 Next.js 15，则 next 的 TypeScript 类型和 API 也将是 Next.js 15。"
  }, {
    "heading": "示例-example",
    "content": "¥The version of next that will be resolved for the package will come from the consumers of the library. For example, if Next.js 15 is installed in your applications, the TypeScript types and APIs for next will also be Next.js 15."
  }, {
    "heading": "使用入口点拆分框架绑定-splitting-framework-bindings-using-entrypoints",
    "content": "¥Splitting framework bindings using entrypoints"
  }, {
    "heading": "使用入口点拆分框架绑定-splitting-framework-bindings-using-entrypoints",
    "content": "使用导出路径将包拆分为特定于框架的入口点是向旨在支持多个框架的库添加绑定的最简单方法。通过拆分入口点，打包工具可以更轻松地理解你计划定位的框架，并且你不太可能看到奇怪的打包错误。"
  }, {
    "heading": "使用入口点拆分框架绑定-splitting-framework-bindings-using-entrypoints",
    "content": "¥Using export paths to split a package into framework-specific entrypoints is the simplest way to add bindings to a library that aims to support multiple frameworks. By splitting entrypoints, bundlers have an easier time understanding the framework you intend to target and you're less likely to see strange bundling errors."
  }, {
    "heading": "使用入口点拆分框架绑定-splitting-framework-bindings-using-entrypoints",
    "content": "下面的示例展示了一个包含两个入口点的库，每个入口点对应不同类型的链接组件。这些抽象可能包含你自己的样式、API 以及它们所封装元素之上的其他调整。"
  }, {
    "heading": "使用入口点拆分框架绑定-splitting-framework-bindings-using-entrypoints",
    "content": "¥The example below shows a library with two entrypoints, each for a different type of link component. These abstractions likely contain your own styles, APIs, and other adjustments on top of the element they're wrapping."
  }, {
    "heading": "使用入口点拆分框架绑定-splitting-framework-bindings-using-entrypoints",
    "content": "./link：一个 <a> HTML 标签，其中包含一些来自你的设计系统的默认样式。"
  }, {
    "heading": "使用入口点拆分框架绑定-splitting-framework-bindings-using-entrypoints",
    "content": "¥./link: An <a> HTML tag with some default styles from your design system"
  }, {
    "heading": "使用入口点拆分框架绑定-splitting-framework-bindings-using-entrypoints",
    "content": "./next-js/link：Next.js Link 组件 的定制版本，其 props 已根据你组织的偏好进行预设。"
  }, {
    "heading": "使用入口点拆分框架绑定-splitting-framework-bindings-using-entrypoints",
    "content": "¥./next-js/link: A customized version of the Next.js Link component with props that are preset to your organization's preferences"
  }, {
    "heading": "使用入口点拆分框架绑定-splitting-framework-bindings-using-entrypoints",
    "content": "./svelte/link：带有预设的 Svelte 的 a 标签 的定制版本。"
  }, {
    "heading": "使用入口点拆分框架绑定-splitting-framework-bindings-using-entrypoints",
    "content": "¥./svelte/link: A customized version of an a tag for Svelte with presets."
  }, {
    "heading": "使用入口点拆分框架绑定-splitting-framework-bindings-using-entrypoints",
    "content": "在上面的示例中，next 的 peerDependency 接受任何版本。你可能需要根据需要指定一个范围（例如，\">=15\"）。"
  }, {
    "heading": "使用入口点拆分框架绑定-splitting-framework-bindings-using-entrypoints",
    "content": "¥In the example above, the peerDependency for next accepts any version. You\nmay want to specify a range (for example, \">=15\") according to your needs."
  }, {
    "heading": "使用入口点拆分框架绑定-splitting-framework-bindings-using-entrypoints",
    "content": "此概念可应用于你想要提供绑定的任意数量的框架或其他依赖。"
  }, {
    "heading": "使用入口点拆分框架绑定-splitting-framework-bindings-using-entrypoints",
    "content": "¥This concept can be applied to any number of frameworks or other dependencies that you'd like to provide bindings for."
  }],
  "headings": [{
    "id": "示例-example",
    "content": "示例 /*example*/"
  }, {
    "id": "使用入口点拆分框架绑定-splitting-framework-bindings-using-entrypoints",
    "content": "使用入口点拆分框架绑定 /*splitting-framework-bindings-using-entrypoints*/"
  }]
};
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#示例-example",
  title: _jsx(_Fragment, {
    children: "示例 "
  })
}, {
  depth: 2,
  url: "#使用入口点拆分框架绑定-splitting-framework-bindings-using-entrypoints",
  title: _jsx(_Fragment, {
    children: "使用入口点拆分框架绑定 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/core-concepts/package-types#library-packages",
        children: "库软件包"
      }), " 中的框架绑定通过在库中直接利用框架的 API，将你的库代码与框架更深入地集成。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Framework bindings in a ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-types#library-packages",
        children: "Library Package"
      }), " integrate your library's code more deeply with a framework by leveraging APIs from the framework directly in the library."]
    }), "\n", _jsxs(_components.p, {
      children: ["为此，请在库的 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中使用 ", _jsx(_components.code, {
        children: "peerDependencies"
      }), " 字段，这使得框架 API 在你的库中可用，而无需将其直接安装在包中。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To do this, use the ", _jsx(_components.code, {
        children: "peerDependencies"
      }), " field in ", _jsx(_components.code, {
        children: "package.json"
      }), " of the library, which makes the framework APIs available in your library without installing it directly in the package."]
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsx(_components.p, {
        children: "在本页面中，我们将使用 Next.js 作为示例，但以下概念适用于任何框架或其他依赖。"
      }), _jsx(_components.p, {
        children: "¥On this page, we'll be using Next.js for examples, but the concepts below\napply to any framework or other dependency."
      })]
    }), "\n", _jsx(_components.h2, {
      id: "示例-example",
      children: "示例 "
    }), "\n", _jsx(_components.p, {
      children: "¥Example"
    }), "\n", _jsxs(_components.p, {
      children: ["将 ", _jsx(_components.code, {
        children: "peerDependency"
      }), " 添加到你要为其创建绑定的依赖的库中。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Add a ", _jsx(_components.code, {
        children: "peerDependency"
      }), " to your library for the dependency that you intend to create bindings for."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/ui/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"name\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"@repo/ui\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"peerDependencies\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"next\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"*\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsxs(_components.p, {
        children: ["在上面的示例中，", _jsx(_components.code, {
          children: "next"
        }), " 的 ", _jsx(_components.code, {
          children: "peerDependency"
        }), " 接受任何版本。你可能需要根据需要指定一个范围（例如，", _jsx(_components.code, {
          children: "\">=15\""
        }), "）。此外，对于较旧的包管理器，你可能需要指示包管理器使用配置安装对等依赖，或者将依赖添加到 ", _jsx(_components.code, {
          children: "devDependencies"
        }), " 作为解决方法。"]
      }), _jsxs(_components.p, {
        children: ["¥In the example above, the ", _jsx(_components.code, {
          children: "peerDependency"
        }), " for ", _jsx(_components.code, {
          children: "next"
        }), " accepts any version. You\nmay want to specify a range (for example, ", _jsx(_components.code, {
          children: "\">=15\""
        }), ") according to your needs.\nAdditionally, for older package managers, you may need to instruct your\npackage manager to install peer dependencies with configuration, or add the\ndependency to ", _jsx(_components.code, {
          children: "devDependencies"
        }), " as a workaround."]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["这将使依赖在你的库中可用，允许你编写如下所示的代码。注意 ", _jsx(_components.code, {
        children: "className"
      }), " 属性，它为 monorepo 中的组件设置了默认样式，并且可以在 ", _jsx(_components.code, {
        children: "props"
      }), " 对象中覆盖它。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This will make the dependency available in your library, allowing you to write code like below. Note the ", _jsx(_components.code, {
        children: "className"
      }), " prop, which sets a default styling for this component in the monorepo and can be overridden in the ", _jsx(_components.code, {
        children: "props"
      }), " object."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/ui/src/link.tsx",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M14.23 12.004a2.236 2.236 0 0 1-2.235 2.236 2.236 2.236 0 0 1-2.236-2.236 2.236 2.236 0 0 1 2.235-2.236 2.236 2.236 0 0 1 2.236 2.236zm2.648-10.69c-1.346 0-3.107.96-4.888 2.622-1.78-1.653-3.542-2.602-4.887-2.602-.41 0-.783.093-1.106.278-1.375.793-1.683 3.264-.973 6.365C1.98 8.917 0 10.42 0 12.004c0 1.59 1.99 3.097 5.043 4.03-.704 3.113-.39 5.588.988 6.38.32.187.69.275 1.102.275 1.345 0 3.107-.96 4.888-2.624 1.78 1.654 3.542 2.603 4.887 2.603.41 0 .783-.09 1.106-.275 1.374-.792 1.683-3.263.973-6.365C22.02 15.096 24 13.59 24 12.004c0-1.59-1.99-3.097-5.043-4.032.704-3.11.39-5.587-.988-6.38-.318-.184-.688-.277-1.092-.278zm-.005 1.09v.006c.225 0 .406.044.558.127.666.382.955 1.835.73 3.704-.054.46-.142.945-.25 1.44-.96-.236-2.006-.417-3.107-.534-.66-.905-1.345-1.727-2.035-2.447 1.592-1.48 3.087-2.292 4.105-2.295zm-9.77.02c1.012 0 2.514.808 4.11 2.28-.686.72-1.37 1.537-2.02 2.442-1.107.117-2.154.298-3.113.538-.112-.49-.195-.964-.254-1.42-.23-1.868.054-3.32.714-3.707.19-.09.4-.127.563-.132zm4.882 3.05c.455.468.91.992 1.36 1.564-.44-.02-.89-.034-1.345-.034-.46 0-.915.01-1.36.034.44-.572.895-1.096 1.345-1.565zM12 8.1c.74 0 1.477.034 2.202.093.406.582.802 1.203 1.183 1.86.372.64.71 1.29 1.018 1.946-.308.655-.646 1.31-1.013 1.95-.38.66-.773 1.288-1.18 1.87-.728.063-1.466.098-2.21.098-.74 0-1.477-.035-2.202-.093-.406-.582-.802-1.204-1.183-1.86-.372-.64-.71-1.29-1.018-1.946.303-.657.646-1.313 1.013-1.954.38-.66.773-1.286 1.18-1.868.728-.064 1.466-.098 2.21-.098zm-3.635.254c-.24.377-.48.763-.704 1.16-.225.39-.435.782-.635 1.174-.265-.656-.49-1.31-.676-1.947.64-.15 1.315-.283 2.015-.386zm7.26 0c.695.103 1.365.23 2.006.387-.18.632-.405 1.282-.66 1.933-.2-.39-.41-.783-.64-1.174-.225-.392-.465-.774-.705-1.146zm3.063.675c.484.15.944.317 1.375.498 1.732.74 2.852 1.708 2.852 2.476-.005.768-1.125 1.74-2.857 2.475-.42.18-.88.342-1.355.493-.28-.958-.646-1.956-1.1-2.98.45-1.017.81-2.01 1.085-2.964zm-13.395.004c.278.96.645 1.957 1.1 2.98-.45 1.017-.812 2.01-1.086 2.964-.484-.15-.944-.318-1.37-.5-1.732-.737-2.852-1.706-2.852-2.474 0-.768 1.12-1.742 2.852-2.476.42-.18.88-.342 1.356-.494zm11.678 4.28c.265.657.49 1.312.676 1.948-.64.157-1.316.29-2.016.39.24-.375.48-.762.705-1.158.225-.39.435-.788.636-1.18zm-9.945.02c.2.392.41.783.64 1.175.23.39.465.772.705 1.143-.695-.102-1.365-.23-2.006-.386.18-.63.406-1.282.66-1.933zM17.92 16.32c.112.493.2.968.254 1.423.23 1.868-.054 3.32-.714 3.708-.147.09-.338.128-.563.128-1.012 0-2.514-.807-4.11-2.28.686-.72 1.37-1.536 2.02-2.44 1.107-.118 2.154-.3 3.113-.54zm-11.83.01c.96.234 2.006.415 3.107.532.66.905 1.345 1.727 2.035 2.446-1.595 1.483-3.092 2.295-4.11 2.295-.22-.005-.406-.05-.553-.132-.666-.38-.955-1.834-.73-3.703.054-.46.142-.944.25-1.438zm4.56.64c.44.02.89.034 1.345.034.46 0 .915-.01 1.36-.034-.44.572-.895 1.095-1.345 1.565-.455-.47-.91-.993-1.36-1.565z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "import"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " Link "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "from"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " 'next/link'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ";"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "import"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " type"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { ComponentProps } "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "from"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " 'react'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ";"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "type"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " CustomLinkProps"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " ="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " ComponentProps"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "<"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "typeof"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " Link>;"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "export"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " function"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " CustomLink"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "({ children"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " ..."
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "props }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " CustomLinkProps"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ") {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  return"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ("
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    <"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "Link"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " className"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"text-underline hover:text-green-400\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "..."
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "props}>"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      {children}"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    </"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "Link"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ">"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  );"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["将为包解析的 ", _jsx(_components.code, {
        children: "next"
      }), " 版本将来自库的使用者。例如，如果你的应用中安装了 Next.js 15，则 ", _jsx(_components.code, {
        children: "next"
      }), " 的 TypeScript 类型和 API 也将是 Next.js 15。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The version of ", _jsx(_components.code, {
        children: "next"
      }), " that will be resolved for the package will come from the consumers of the library. For example, if Next.js 15 is installed in your applications, the TypeScript types and APIs for ", _jsx(_components.code, {
        children: "next"
      }), " will also be Next.js 15."]
    }), "\n", _jsx(_components.h2, {
      id: "使用入口点拆分框架绑定-splitting-framework-bindings-using-entrypoints",
      children: "使用入口点拆分框架绑定 "
    }), "\n", _jsx(_components.p, {
      children: "¥Splitting framework bindings using entrypoints"
    }), "\n", _jsx(_components.p, {
      children: "使用导出路径将包拆分为特定于框架的入口点是向旨在支持多个框架的库添加绑定的最简单方法。通过拆分入口点，打包工具可以更轻松地理解你计划定位的框架，并且你不太可能看到奇怪的打包错误。"
    }), "\n", _jsx(_components.p, {
      children: "¥Using export paths to split a package into framework-specific entrypoints is the simplest way to add bindings to a library that aims to support multiple frameworks. By splitting entrypoints, bundlers have an easier time understanding the framework you intend to target and you're less likely to see strange bundling errors."
    }), "\n", _jsx(_components.p, {
      children: "下面的示例展示了一个包含两个入口点的库，每个入口点对应不同类型的链接组件。这些抽象可能包含你自己的样式、API 以及它们所封装元素之上的其他调整。"
    }), "\n", _jsx(_components.p, {
      children: "¥The example below shows a library with two entrypoints, each for a different type of link component. These abstractions likely contain your own styles, APIs, and other adjustments on top of the element they're wrapping."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "./link"
          }), "：一个 ", _jsx(_components.code, {
            children: "<a>"
          }), " HTML 标签，其中包含一些来自你的设计系统的默认样式。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "./link"
          }), ": An ", _jsx(_components.code, {
            children: "<a>"
          }), " HTML tag with some default styles from your design system"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "./next-js/link"
          }), "：", _jsxs(_components.a, {
            href: "https://next.nodejs.cn/docs/app/building-your-application/routing/linking-and-navigating#link-component",
            children: ["Next.js ", _jsx(_components.code, {
              children: "Link"
            }), " 组件"]
          }), " 的定制版本，其 props 已根据你组织的偏好进行预设。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "./next-js/link"
          }), ": A customized version of ", _jsxs(_components.a, {
            href: "https://next.nodejs.cn/docs/app/building-your-application/routing/linking-and-navigating#link-component",
            children: ["the Next.js ", _jsx(_components.code, {
              children: "Link"
            }), " component"]
          }), " with props that are preset to your organization's preferences"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "./svelte/link"
          }), "：带有预设的 ", _jsxs(_components.a, {
            href: "https://svelte.nodejs.cn/docs/kit/link-options",
            children: ["Svelte 的 ", _jsx(_components.code, {
              children: "a"
            }), " 标签"]
          }), " 的定制版本。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "./svelte/link"
          }), ": A customized version of an ", _jsxs(_components.a, {
            href: "https://svelte.nodejs.cn/docs/kit/link-options",
            children: [_jsx(_components.code, {
              children: "a"
            }), " tag for Svelte"]
          }), " with presets."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/ui/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"exports\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"./link\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./dist/link.js\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"./next-js/link\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./dist/next-js/link.js\""
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"peerDependencies\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"next\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"*\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsxs(_components.p, {
        children: ["在上面的示例中，", _jsx(_components.code, {
          children: "next"
        }), " 的 ", _jsx(_components.code, {
          children: "peerDependency"
        }), " 接受任何版本。你可能需要根据需要指定一个范围（例如，", _jsx(_components.code, {
          children: "\">=15\""
        }), "）。"]
      }), _jsxs(_components.p, {
        children: ["¥In the example above, the ", _jsx(_components.code, {
          children: "peerDependency"
        }), " for ", _jsx(_components.code, {
          children: "next"
        }), " accepts any version. You\nmay want to specify a range (for example, ", _jsx(_components.code, {
          children: "\">=15\""
        }), ") according to your needs."]
      })]
    }), "\n", _jsx(_components.p, {
      children: "此概念可应用于你想要提供绑定的任意数量的框架或其他依赖。"
    }), "\n", _jsx(_components.p, {
      children: "¥This concept can be applied to any number of frameworks or other dependencies that you'd like to provide bindings for."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
